import React from 'react';
import { Helmet } from 'react-helmet';

import { LoadGoogleAnalytics } from 'web-services/GoogleAnalytics';

const GoogleHelmet = () => (
  <Helmet key='google-head-helmet'>
    {LoadGoogleAnalytics({
      appEnv: process.env.REACT_APP_ENV,
      includeOptimize: true,
      includeTagManager: true,
      useHelmetSyntax: true
    })}
  </Helmet>
);

export default GoogleHelmet;
